import Roof from './roof.js'
let text = window.text; // We depend on global localization

export default class HippedRoof extends Roof {
  constructor(r,p) {
    super(r,p)

    this.inputs = [
      {
        name: "length",
        title: text.length
      },
      {
        name: "width",
        title: text.width
      },
      {
        name: "height",
        title: text.height,
        alternatives:{
          names: ["angle"],
          convertTo: function(propertyName, height, values){
            if (propertyName == "height"){
              return height;
            }
            return Roof.angle(height,values["width"])*Roof.radianToDegree();
          },
          convertFrom: function(propertyName, propertyValue, values){
            if (propertyName == "height"){
              return propertyValue;
            }
            let angle = propertyValue*Roof.degreeToRadian();
            return Roof.angleToHeight(values["width"], angle);
          },
        },
      },
      {
        name: "endl",
        title: text.lend
      },
    ]

    this.name = text.rHipped
    this.description = text.rdHipped
  }

  angleToHeight(angle){
    return Math.tan(angle/180*Math.PI)*this.props.width/2.0;
  }

	pipes() {
		let i = this.props
		return [i.length, i.length, i.width, i.width]
  }
  
  vindski() {
    return 0;
  }

  mone() {
    let moneTop = this.props.length - 2 * this.props.endl

    let arad = this.getAngleRad()
    let w = this.props.width/2;
    let w1 = w/Math.cos(arad)
    let moneDiag = Math.sqrt(this.props.endl*this.props.endl + w1*w1);

    return 4*moneDiag + moneTop;
  }

  validateInput(inputs){
    if (inputs == undefined){
      return undefined;
    }
    let ret = {}
    let hasError = false;
    if (inputs.endl > inputs.length/2){
      ret["endl"] = text.errLengthEnd
      hasError = true 
    }
    if(hasError){
      return ret;
    }
    return undefined;
  }

  getAngleRad(){
    return Roof.angle(this.props.height, this.props.width)
    //return Math.atan2(this.props.height, (this.props.width/2));
  }

  topatches() {
    let arad = this.getAngleRad()
    let w = this.props.width/2;
    let w1 = 1000*w/Math.cos(arad)
    let h = w*Math.tan(arad)
    let l1 = 1000*Math.sqrt(this.props.endl*this.props.endl + h*h)

    let patches = [
      this.fromarr(
        0,0,
        1000*(this.props.endl),w1,
        1000*(this.props.length-this.props.endl), w1,
        1000*this.props.length, 0
      ),
      this.fromarr(
        0,0,
        1000*(this.props.endl),w1,
        1000*(this.props.length-this.props.endl), w1,
        1000*this.props.length, 0
      ),
      this.fromtriangle(1000*this.props.width,l1 ),
      this.fromtriangle(1000*this.props.width,l1 ),
    ];
    return patches
  }

  patchtransforms() {
    let arad = this.getAngleRad()
    let w = this.props.width/2;
    let w1 = 1000*w/Math.cos(arad)
    let h = w*Math.tan(arad)
    let l1 = 1000*Math.sqrt(this.props.endl*this.props.endl + h*h)

    let off = 1000*this.props.width/20
    return [
      {
        t: [-1000*this.props.length/2, -w1-off],
        r: [0, 0, 0],
      },
      {
        t: [-1000*this.props.length/2, -w1-off],
        r: [180, 0, 0],
      },
      {
        t: [-500*this.props.width-500*this.props.length+1000*this.props.endl, -l1-off],
        r: [-90, -500*this.props.length+1000*this.props.endl, 0],
      },
      {
        t: [-500*this.props.width+500*this.props.length-+1000*this.props.endl, -l1-off],
        r: [90, +500*this.props.length-1000*this.props.endl, 0],
      },
    ]
  }

}



// WEBPACK FOOTER //
// ./roofs/hippedroof.js